import { IQuestionModel } from '@care-portals/api-interfaces';

const caDrugCards = [
  { adjudicator: 'Discount-STI-ESI', plan: 'Discount Card ESI' },
  { adjudicator: 'Discount-NX', plan: 'Discount Card NX' },
  { adjudicator: 'CS', plan: 'Claimsecure' },
  { adjudicator: 'sunlife-ESI', plan: 'SunLife' },
  { adjudicator: 'Manulife-ESI', plan: 'Manulife' },
  { adjudicator: 'OTIP-ESI', plan: 'OTIP' },
  { adjudicator: 'Empire-ESI', plan: 'Empire Life' },
  { adjudicator: 'IA-ESI', plan: 'Industrial Alliance (IA)' },
  { adjudicator: 'Johnson-ESI', plan: 'Johnson Inc' },
  // { adjudicator: 'NHIB-ESI', plan: 'NHIB' },
  { adjudicator: 'RWAM-ESI', plan: 'RWAM' },
  { adjudicator: 'Canadalife-AHE', plan: 'Canada Life' },
  { adjudicator: 'GWL-AHE', plan: 'Great West Life (GWL)' },
  { adjudicator: 'Des-AHE', plan: 'Desjardins' },
  { adjudicator: 'Equitable-AHE', plan: 'Equitable Life' },
  { adjudicator: 'PSHCP-AHE', plan: 'Public Service Health Care Plan' },
  { adjudicator: 'Johnston-AHE', plan: 'Johnston Group' },
  { adjudicator: 'Ontario-OBC', plan: 'Ontario Blue Cross' },
  { adjudicator: 'Medvie-OBC', plan: 'Medavie Blue Cross' },
  { adjudicator: 'ABBC', plan: 'Alberta Blue Cross' },
  { adjudicator: 'MBC', plan: 'Manitoba Blue Cross' },
  { adjudicator: 'SBC', plan: 'Saskatchewan Blue Cross' },
  { adjudicator: 'GSC', plan: 'Greenshield' },
  { adjudicator: 'RBC-GSC', plan: 'RBC Insurance' },
  { adjudicator: 'PBC', plan: 'Pacific Blue Cross' },
  { adjudicator: 'MDM', plan: 'MDM Guard' },
  { adjudicator: 'NX', plan: 'NexgenRx' },
  { adjudicator: 'CBP', plan: 'Canadian Benefit Providers' },
  { adjudicator: 'RCMP', plan: 'RCMP' },
  { adjudicator: 'SSQ', plan: 'SSQ' }
];

const questionsModels: IQuestionModel[] = [
  /**
   * Drug Card Form
   */
  {
    label: 'Add your insurance for hassle free direct billing?',
    field: 'drugCardExists',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    }
  },
  {
    label: 'Please choose your Drug Card Plan.',
    field: 'drugCardPlan',
    type: 'info',
    answer: {
      type: 'dropdown',
      name: 'plan',
      placeholder: 'Please select your card type',
      options: caDrugCards.map(item => ({
        key: item.adjudicator,
        value: item.plan
      }))
    }
  },
  {
    label: 'Please input your drug card info',
    field: 'drugCardInfo',
    type: 'info',
    answer: {
      type: 'branch',
      items: [
        {
          condition: { key: 'drugCardPlan.plan', operator: 'eq', value: 'CS' },
          answer: {
            qImage: 'https://cdn.buttercms.com/CYym6uGQRSBqsb9NeNzg',
            type: 'list',
            items: [
              {
                label: 'Please enter your drug card Group number',
                type: 'number',
                name: 'groupNum',
                placeholder: '4-6 digits'
              },
              {
                label: 'Please enter your drug card Certificate number',
                type: 'text',
                name: 'certificateNum',
                placeholder: '10-12 digits/letters'
              }
            ]
          }
        },
        {
          condition: {
            key: 'drugCardPlan.plan',
            operator: 'eq',
            value: 'sunlife-ESI'
          },
          answer: {
            qImage: 'https://cdn.buttercms.com/nYJWSfECRNmUNE3YSkHu',
            type: 'list',
            items: [
              {
                label: 'Please enter your drug card Carrier number',
                type: 'number',
                name: 'carrierNum',
                placeholder: '2 digits'
              },
              {
                label: 'Please enter your drug card Contract number',
                type: 'number',
                name: 'groupNum',
                placeholder: '6 digits, please include any 0s '
              },
              {
                label: 'Please enter your drug card Member ID',
                type: 'text',
                name: 'certificateNum',
                placeholder: '10-12 digits/letters'
              }
            ]
          }
        },
        {
          condition: {
            key: 'drugCardPlan.plan',
            operator: 'eq',
            value: 'Manulife-ESI'
          },
          answer: {
            qImage: 'https://cdn.buttercms.com/XPMmT1m4TqiOpM4LNaFh',
            type: 'list',
            items: [
              {
                label: 'Please enter your drug card Plan Contract number',
                type: 'number',
                name: 'groupNum',
                placeholder: '6-7 digits, please include any 0s '
              },
              {
                label: 'Please enter your drug card Member Certificate Number ',
                type: 'text',
                name: 'certificateNum',
                placeholder: '7-10 digits'
              },
              {
                label: 'Please enter your drug card Carrier ',
                type: 'text',
                name: 'carrierNum',
                placeholder: '2 digits, enter NA if empty'
              }
            ]
          }
        },
        {
          condition: {
            key: 'drugCardPlan.plan',
            operator: 'eq',
            value: 'OTIP-ESI'
          },
          answer: {
            qImage: 'https://cdn.buttercms.com/QK5jO7MRky2O4oJs8WoU',
            type: 'list',
            items: [
              {
                label: 'Please enter your drug card Plan number',
                type: 'number',
                name: 'groupNum',
                placeholder: '6 digits, please include any 0s '
              },
              {
                label: 'Please enter your drug card Identification Number ',
                type: 'text',
                name: 'certificateNum',
                placeholder: '7 digits'
              }
            ]
          }
        },
        {
          condition: {
            key: 'drugCardPlan.plan',
            operator: 'eq',
            value: 'Empire-ESI'
          },
          answer: {
            qImage: 'https://cdn.buttercms.com/UKN2fVfqTjiGejedEc9p',
            type: 'list',
            items: [
              {
                label: 'Please enter your drug card Drug Group number',
                type: 'number',
                name: 'groupNum',
                placeholder: '6 digits, please include any 0s '
              },
              {
                label: 'Please enter your drug card Certificate Number ',
                type: 'text',
                name: 'certificateNum',
                placeholder: '10 digits'
              }
            ]
          }
        },
        {
          condition: {
            key: 'drugCardPlan.plan',
            operator: 'eq',
            value: 'IA-ESI'
          },
          answer: {
            qImage: 'https://cdn.buttercms.com/f6xAmHQdQCqUrkoNCRdx',
            type: 'list',
            items: [
              {
                label: 'Please enter your drug card Policy number',
                type: 'number',
                name: 'groupNum',
                placeholder: '5 digits, please include any 0s '
              },
              {
                label: 'Please enter your drug card Member ID number ',
                type: 'text',
                name: 'certificateNum',
                placeholder: '9 digits'
              }
            ]
          }
        },
        {
          condition: {
            key: 'drugCardPlan.plan',
            operator: 'eq',
            value: 'Johnson-ESI'
          },
          answer: {
            qImage: 'https://cdn.buttercms.com/UptIs6dOTAOK5dnRsssv',
            type: 'list',
            items: [
              {
                label: 'Please enter your drug card Carrier number',
                type: 'number',
                name: 'carrierNum',
                placeholder: '2 digits '
              },
              {
                label: 'Please enter your drug card Policy number ',
                type: 'text',
                name: 'groupNum',
                placeholder: '6 digits'
              },
              {
                label: 'Please enter your drug card ID number',
                type: 'number',
                name: 'certificateNum',
                placeholder: 'All charachters of ID#'
              }
            ]
          }
        },
        {
          condition: {
            key: 'drugCardPlan.plan',
            operator: 'eq',
            value: 'RWAM-ESI'
          },
          answer: {
            qImage: 'https://cdn.buttercms.com/m1cgWwCvRXSrcYAsxTbN',
            type: 'list',
            items: [
              /*{
                    label: 'Please enter your drug card Carrier number',
                    type: 'number',
                    name: 'carrierNum',
                    placeholder: '2 digits '
                  },*/
              {
                label: 'Please enter your drug card Policy number ',
                type: 'text',
                name: 'groupNum',
                placeholder: '6 digits'
              },
              {
                label: 'Please enter your drug card Member ID number',
                type: 'number',
                name: 'certificateNum',
                placeholder: 'All charachters of ID#'
              }
            ]
          }
        },
        {
          condition: {
            key: 'drugCardPlan.plan',
            operator: 'eq',
            value: 'Discount-STI-ESI'
          },
          answer: {
            type: 'list',
            items: [
              {
                label: 'Please enter the Carrier number',
                type: 'number',
                name: 'carrierNum',
                placeholder: '2 digits '
              },
              {
                label: 'Please enter the Group number ',
                type: 'text',
                name: 'groupNum',
                placeholder: '3 digits'
              },
              {
                label: 'Please enter the client ID number',
                type: 'text',
                name: 'certificateNum',
                placeholder: 'All characters of ID#'
              }
            ]
          }
        },
        {
          condition: {
            key: 'drugCardPlan.plan',
            operator: 'eq',
            value: 'Discount-NX'
          },
          answer: {
            type: 'list',
            items: [
              {
                label: 'Please enter the Carrier number',
                type: 'number',
                name: 'carrierNum',
                placeholder: '2 digits '
              },
              {
                label: 'Please enter the Group number ',
                type: 'text',
                name: 'groupNum',
                placeholder: '3 digits'
              },
              {
                label: 'Please enter the client ID number',
                type: 'text',
                name: 'certificateNum',
                placeholder: 'All characters of ID#'
              }
            ]
          }
        },
        {
          condition: {
            key: 'drugCardPlan.plan',
            operator: 'eq',
            value: 'Canadalife-AHE'
          },
          answer: {
            qImage: 'https://cdn.buttercms.com/90TSRb13RL4MDt42CZ77',
            type: 'list',
            items: [
              {
                label: 'Please enter your drug card Plan number ',
                type: 'text',
                name: 'groupNum',
                placeholder: '6 digits'
              },
              {
                label: 'Please enter your drug card Member ID number',
                type: 'number',
                name: 'certificateNum',
                placeholder: '10 digits'
              }
            ]
          }
        },
        {
          condition: {
            key: 'drugCardPlan.plan',
            operator: 'eq',
            value: 'GWL-AHE'
          },
          answer: {
            qImage: 'https://cdn.buttercms.com/2PNFSKNQRHyptpMX4fKY',
            type: 'list',
            items: [
              {
                label: 'Please enter your drug card Plan number ',
                type: 'text',
                name: 'groupNum',
                placeholder: '6 digits'
              },
              {
                label: 'Please enter your drug card Member ID number',
                type: 'number',
                name: 'certificateNum',
                placeholder: '10 digits'
              }
            ]
          }
        },
        {
          condition: {
            key: 'drugCardPlan.plan',
            operator: 'eq',
            value: 'Des-AHE'
          },
          answer: {
            qImage: 'https://cdn.buttercms.com/M3UaCbWHSPSNmPEfnnvK',
            type: 'list',
            items: [
              {
                label: 'Please enter your drug card Group number ',
                type: 'text',
                name: 'groupNum',
                placeholder: '7 digits'
              },
              {
                label: 'Please enter your drug card Certificate number',
                type: 'number',
                name: 'certificateNum',
                placeholder: '9 digits'
              }
            ]
          }
        },
        {
          condition: {
            key: 'drugCardPlan.plan',
            operator: 'eq',
            value: 'Equitable-AHE'
          },
          answer: {
            qImage: 'https://cdn.buttercms.com/M3ShnAExR7eJa7oX7K4f',
            type: 'list',
            items: [
              {
                label: 'Please enter your drug card Policy number ',
                type: 'text',
                name: 'groupNum',
                placeholder: '6 digits'
              },
              {
                label: 'Please enter your drug card Certificate number',
                type: 'number',
                name: 'certificateNum',
                placeholder: '10 digits, Please include all 0s'
              }
            ]
          }
        },
        {
          condition: {
            key: 'drugCardPlan.plan',
            operator: 'eq',
            value: 'PSHCP-AHE'
          },
          answer: {
            qImage: 'https://cdn.buttercms.com/CDXlFtEtRQGBQKaLptDi',
            type: 'list',
            items: [
              {
                label: 'Please enter your drug card Plan number ',
                type: 'text',
                name: 'groupNum',
                placeholder: '6 digits'
              },
              {
                label: 'Please enter your drug card Certificate number',
                type: 'number',
                name: 'certificateNum',
                placeholder: '10 digits, Please include all 0s'
              }
            ]
          }
        },
        {
          condition: {
            key: 'drugCardPlan.plan',
            operator: 'eq',
            value: 'Johnston-AHE'
          },
          answer: {
            qImage: 'https://cdn.buttercms.com/9TlxnxxRRW3ryWWwYkbQ',
            type: 'list',
            items: [
              {
                label: 'Please enter your drug card Carrier number',
                type: 'number',
                name: 'carrierNum',
                placeholder: '2 digits '
              },
              {
                label: 'Please enter your drug card Policy number ',
                type: 'text',
                name: 'groupNum',
                placeholder: '6 digits'
              },
              {
                label: 'Please enter your drug card Certificate number',
                type: 'number',
                name: 'certificateNum',
                placeholder: '10 digits, Please include all 0s'
              },
              {
                label: 'Please enter your drug card Issue number',
                type: 'number',
                name: 'issueNum',
                placeholder: '2 digits'
              }
            ]
          }
        },
        {
          condition: {
            key: 'drugCardPlan.plan',
            operator: 'eq',
            value: 'Ontario-OBC'
          },
          answer: {
            qImage: 'https://cdn.buttercms.com/s5nGYxpjR3KNJTvDjs9H',
            type: 'list',
            items: [
              {
                label: 'Please enter your drug card Identification number ',
                type: 'text',
                name: 'certificateNum',
                placeholder: '12 digits, please include leading 0s'
              },
              {
                label: 'Please enter your drug card Policy number',
                type: 'number',
                name: 'groupNum',
                placeholder: '10 digits, Please include all 0s'
              }
            ]
          }
        },
        {
          condition: {
            key: 'drugCardPlan.plan',
            operator: 'eq',
            value: 'Medvie-OBC'
          },
          answer: {
            qImage: 'https://cdn.buttercms.com/s5nGYxpjR3KNJTvDjs9H',
            type: 'list',
            items: [
              {
                label: 'Please enter your drug card Identification number ',
                type: 'text',
                name: 'certificateNum',
                placeholder: '12 digits, please include leading 0s'
              },
              {
                label: 'Please enter your drug card Policy number',
                type: 'number',
                name: 'groupNum',
                placeholder: '10 digits, Please include all 0s'
              }
            ]
          }
        },
        {
          condition: {
            key: 'drugCardPlan.plan',
            operator: 'eq',
            value: 'ABBC'
          },
          answer: {
            qImage: 'https://cdn.buttercms.com/NTGNS7mLShurw4teujvU',
            type: 'list',
            items: [
              {
                label: 'Please enter your drug card Group number',
                type: 'number',
                name: 'groupNum',
                placeholder: '7 digits'
              },
              {
                label: 'Please enter your drug card Identification number',
                type: 'text',
                name: 'certificateNum',
                placeholder: '6-7 digits, please include leading 0s'
              },
              {
                label: 'Please enter your drug card Section number',
                type: 'text',
                name: 'sectioNum',
                placeholder: '2 digits after "-" in ID number'
              }
            ]
          }
        },
        {
          condition: { key: 'drugCardPlan.plan', operator: 'eq', value: 'MBC' },
          answer: {
            qImage: 'https://cdn.buttercms.com/swC0l8sKQdWKwfPTOH29',
            type: 'list',
            items: [
              {
                label: 'Please enter your drug card Certificate number ',
                type: 'text',
                name: 'certificateNum',
                placeholder: 'Please include all characters'
              },
              {
                label: 'Please enter your drug card Client number',
                type: 'number',
                name: 'groupNum',
                placeholder: 'Please include all characters'
              }
            ]
          }
        },
        {
          condition: { key: 'drugCardPlan.plan', operator: 'eq', value: 'SBC' },
          answer: {
            qImage: 'https://cdn.buttercms.com/LQqTszHUTxGe6fB4KzfL',
            type: 'list',
            items: [
              {
                label: 'Please enter your drug card Policy number',
                type: 'number',
                name: 'groupNum',
                placeholder: '10 digits, include the Group number too'
              },

              {
                label: 'Please enter your drug card Identification number ',
                type: 'text',
                name: 'certificateNum',
                placeholder: '11 digits'
              }
            ]
          }
        },
        {
          condition: { key: 'drugCardPlan.plan', operator: 'eq', value: 'GSC' },
          answer: {
            qImage: 'https://cdn.buttercms.com/rsFLdcCSZOINmXGexQlS',
            type: 'list',
            items: [
              {
                label: 'Please enter your drug card Identification number ',
                type: 'text',
                name: 'certificateNum',
                placeholder: 'All characters before the "-"'
              },
              {
                label:
                  'Please enter your Patient code number, 2 digits after the "-"',
                type: 'text',
                name: 'sectioNum',
                placeholder: '2 digits after "-" in ID number'
              }
            ]
          }
        },
        {
          condition: {
            key: 'drugCardPlan.plan',
            operator: 'eq',
            value: 'RBC-GSC'
          },
          answer: {
            qImage: 'https://cdn.buttercms.com/Cbb1DwGpRLaSIjwWPycG',
            type: 'list',
            items: [
              {
                label: 'Please enter your drug card Identification number ',
                type: 'text',
                name: 'certificateNum',
                placeholder: 'All characters before the "-"'
              },
              {
                label:
                  'Please enter your Patient code number, 2 digits after the "-"',
                type: 'text',
                name: 'sectioNum',
                placeholder: '2 digits after "-" in ID number'
              },

              {
                label: 'Please enter your drug card Policy number',
                type: 'number',
                name: 'groupNum',
                placeholder: '6 digits'
              }
            ]
          }
        },
        {
          condition: { key: 'drugCardPlan.plan', operator: 'eq', value: 'PBC' },
          answer: {
            qImage: 'https://cdn.buttercms.com/SdCrnfaLR92yqL4xTdoT',
            type: 'list',
            items: [
              {
                label: 'Please enter your drug card Policy number ',
                type: 'text',
                name: 'groupNum',
                placeholder: '5 digits'
              },
              {
                label: 'Please enter your drug card Certificate number',
                type: 'number',
                name: 'certificateNum',
                placeholder: '10 digits, Please include all 0s'
              }
            ]
          }
        },
        {
          condition: { key: 'drugCardPlan.plan', operator: 'eq', value: 'MDM' },
          answer: {
            qImage: 'https://cdn.buttercms.com/QnZ4oMV9RfS3e3QtaR2x',
            type: 'list',
            items: [
              {
                label: 'Please enter your drug card Client ID number',
                type: 'number',
                name: 'certificateNum',
                placeholder: '11 digits, Please include all 0s'
              },
              {
                label: 'Please enter your drug card Group Policy number ',
                type: 'text',
                name: 'groupNum',
                placeholder: 'Enter all characters'
              }
            ]
          }
        },
        {
          condition: { key: 'drugCardPlan.plan', operator: 'eq', value: 'NX' },
          answer: {
            qImage: 'https://cdn.buttercms.com/ikbijvdeSnWLctRwggm8',
            type: 'list',
            items: [
              {
                label: 'Please enter your drug card Carrier number',
                type: 'number',
                name: 'carrierNum',
                placeholder: '2 digits '
              },
              {
                label: 'Please enter your drug card Group number ',
                type: 'text',
                name: 'groupNum',
                placeholder: '10 digits'
              },
              {
                label: 'Please enter your drug card Certificate number',
                type: 'number',
                name: 'certificateNum',
                placeholder: '11 digits, Please include all 0s'
              }
            ]
          }
        },
        {
          condition: { key: 'drugCardPlan.plan', operator: 'eq', value: 'CBP' },
          answer: {
            qImage: 'https://cdn.buttercms.com/9Jzpugo0R92NmHGTeccm',
            type: 'list',
            items: [
              {
                label: 'Please enter your drug card Group number ',
                type: 'text',
                name: 'groupNum',
                placeholder: '10 digits'
              },
              {
                label: 'Please enter your drug card Certificate number',
                type: 'number',
                name: 'certificateNum',
                placeholder: '11 digits, Please include all 0s'
              }
            ]
          }
        },
        {
          condition: { key: 'drugCardPlan.plan', operator: 'eq', value: 'SSQ' },
          answer: {
            qImage: 'https://cdn.buttercms.com/LZ6LYmWuQmKsltOCyR9u',
            type: 'list',
            items: [
              {
                label: 'Please enter your drug card Policy number ',
                type: 'text',
                name: 'groupNum',
                placeholder: '5 digits'
              },
              {
                label: 'Please enter your drug card Certificate number',
                type: 'number',
                name: 'certificateNum',
                placeholder: '6 digits, Please include all 0s'
              }
            ]
          }
        },
        {
          condition: {
            key: 'drugCardPlan.plan',
            operator: 'eq',
            value: 'RCMP'
          },
          answer: {
            qImage: 'https://cdn.buttercms.com/s5nGYxpjR3KNJTvDjs9H',
            type: 'list',
            items: [
              {
                label: 'Please enter your drug card Identification number ',
                type: 'text',
                name: 'certificateNum',
                placeholder: '12 digits, please include leading 0s'
              },
              {
                label: 'Please enter your drug card Policy number',
                type: 'number',
                name: 'groupNum',
                placeholder: '10 digits, Please include all 0s'
              }
            ]
          }
        }
      ]
    }
  },
  {
    label: 'First and Last Name as it appears on Drug Card',
    subLabel: '',
    field: 'drugCardName',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'First Name *',
          type: 'text',
          name: 'drugCardFirstName',
          rows: 1,
          placeholder: 'First Name on Card'
        },
        {
          label: 'Last Name *',
          type: 'text',
          name: 'drugCardLastName',
          rows: 1,
          placeholder: 'Last Name on Card'
        }
      ]
    }
  },
  {
    // 2
    label: 'You are the ____________?',
    field: 'drugCardOwner',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: '0',
          value: 'Main Drug Card Holder'
        },
        {
          key: '1',
          value: 'Spouse of the Card owner'
        },
        {
          key: '3',
          value: 'Child/Disabled Dependent '
        },
        {
          key: '5',
          value: 'Dependent Student'
        }
      ]
    }
  },

  {
    // 3
    label: 'Do you have another Drug Card?',
    field: 'drugCardAnother',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes'
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },

  {
    label:
      'Thank you for completing this questionnaire, please select "Finish" to submit',
    field: 'drugCardComplete',
    isLast: true,
    type: 'info',
    answer: {}
  }
];

const createDrugVersion = (
  questions: IQuestionModel[],
  suffix: string
): IQuestionModel[] => {
  return questions.map(question => {
    // Create a deep copy of the question
    const newQuestion = JSON.parse(JSON.stringify(question));

    // Update field names but keep the original answer names
    if (newQuestion.field) {
      newQuestion.field = `${newQuestion.field}${suffix}`;
    }

    // Update condition keys in branch items if they exist
    if (newQuestion.answer?.type === 'branch' && newQuestion.answer.items) {
      newQuestion.answer.items = newQuestion.answer.items.map(item => {
        if (item.condition?.key) {
          const [field, ...rest] = item.condition.key.split('.');
          item.condition.key = `${field}${suffix}.${rest.join('.')}`;
        }
        return item;
      });
    }

    return newQuestion;
  });
};

// Create versions with suffixed fields while keeping original answer names
const drug2Questions = createDrugVersion(questionsModels, '2');
const drug3Questions = createDrugVersion(questionsModels, '3');
const drug4Questions = createDrugVersion(questionsModels, '4');
const drug5Questions = createDrugVersion(questionsModels, '5');

// Export the original questions as default
export default questionsModels;

// Export the additional versions
export { drug2Questions, drug3Questions, drug4Questions, drug5Questions };
